import tocbot from "tocbot"

type TableOfContentsProps = {
  contentSelector: string
  xlStyles: boolean
}

export default function tableOfContents(
  el: HTMLElement,
  props: TableOfContentsProps
) {
  // eslint-disable-next-line import/no-named-as-default-member -- tocbot doesn't actually export a named 'init', only as a method on the default export
  tocbot.init({
    headingSelector: `${props.contentSelector} h2`,
    // navigation heading offset only works with scrollSmooth
    headingsOffset: 84,
    scrollSmoothOffset: -84,
    scrollSmoothDuration: 10,
    // Overide default library classes
    tocSelector: ".table-of-contents",
    contentSelector: `${props.contentSelector}`,
    listClass: `${props.xlStyles ? "table-of-contents__xl-list" : "table-of-contents__list"}`,
    listItemClass: `${props.xlStyles ? "table-of-contents__xl-list-item" : "table-of-contents__list-item"}`,
    linkClass: `${props.xlStyles ? "table-of-contents__xl-link" : "table-of-contents__link"}`,
    activeLinkClass: `${props.xlStyles ? "table-of-contents__xl-active-link" : "table-of-contents__active-link"}`,
    orderedList: false,
    hasInnerContainers: true,
  })

  const hash_link = location.hash
  if (hash_link) {
    // offset navigation scroll
    window.scrollBy(0, -84)
  }

  if (!props.xlStyles) return

  // Add custom classes to the table of contents
  const listItems = document.querySelectorAll(
    ".table-of-contents__xl-list-item"
  )
  listItems.forEach(listItem => {
    const firstChild = listItem.children[0]
    if (firstChild?.innerHTML.includes(":")) {
      const splitString = firstChild.innerHTML.split(":")
      const secondPart = splitString[1]
      const firstPart = splitString[0]
      if (secondPart) {
        firstChild.innerHTML = secondPart
      }
      listItem.innerHTML = `<p class="font-main eyebrow mb-10 desktop:mb-12">${firstPart}</p>${listItem.innerHTML}`
    }
  })
}
